const ExternalRedirect = ({ to, wrapWith }: { to: string; wrapWith?: (url: string) => string }) => {
  window.location.href = wrapWith ? wrapWith(to) : to;
  return null;
};

export default ExternalRedirect;
